import styled from '@emotion/styled'
import {InfoRounded} from '@mui/icons-material'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'

export const StyledSubtitle = styled('h6')(({theme}) => ({
  fontWeight: theme.typography.fontWeightSemibold,
  fontSize: theme.typography.subtitle1.fontSize,
  margin: 0
}))

export const StyledSecondaryButton = styled(Button)(({theme}) => ({
  letterSpacing: '0.5px',
  padding: '20px 8px',
  background: theme.palette.hpAccentTeal,
  height: '32px'
}))

export const StyledAddAdminButton = styled(StyledSecondaryButton)(() => ({
  minWidth: 150,
  marginTop: '8px'
}))

export const StyledAdminsBackground = styled('div')(({theme}) => ({
  backgroundColor: theme.palette.hpBaseLighter,
  padding: theme.spacing(1)
}))

export const StyledRemoveButton = styled(Button)(({theme}) => ({
  color: theme.palette.hpErrorRed,
  background: 'transparent',
  padding: '4px',
  borderRadius: '100%',
  minWidth: 'auto',
  '&:hover': {
    backgroundColor: theme.palette.hpErrorRedLightest
  }
}))

export const StyledConfirmationButton = styled(Button)(({theme}) => ({
  padding: '12px 24px',
  fontSize: theme.typography.body1.fontSize,
  fontWeight: theme.typography.fontWeightSemibold,
  textTransform: 'none',
  letterSpacing: '0.5px',
  borderRadius: theme.shape.borderRadius,
  width: '100%',
  border: 'none',
  '&:hover': {
    border: 'none'
  }
}))

export const StyledConfirmationCancelButton = styled(Button)(({theme}) => ({
  color: theme.palette.hpAccentTeal,
  textTransform: 'none',
  width: '100%',
  fontSize: theme.typography.body1.fontSize,
  fontWeight: theme.typography.fontWeightSemibold,
  '&:hover': {
    background: theme.palette.hpAccentTealLightest
  }
}))

export const StyledProjectConfirmationCancelButton = styled(StyledConfirmationCancelButton)(({theme}) => ({
  fontWeight: theme.typography.fontWeightMedium
}))

export const StyledInfoIcon = styled(InfoRounded)(({theme}) => ({
  fontSize: theme.typography.h2.fontSize,
  color: theme.palette.hpPrimaryDark,
  borderRadius: '50%',
  width: theme.typography.h2.fontSize,
  height: theme.typography.h2.fontSize,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
}))

export const StyledEmptyAdminsMessage = styled(Typography)(({theme}) => ({
  color: theme.palette.hpBaseDarker,
  fontStyle: 'italic'
}))

export const StyledErrorMessage = styled(Typography)(({theme}) => ({
  color: theme.palette.error.main,
  fontSize: theme.typography.body2.fontSize
}))
